export default function getRaisePercent(action) {
	let rPercent = 0;
	if (action === "2") rPercent = 1.0;
	else if (action === "4") rPercent = 0.5;
	else if (action === "9") rPercent = 0.75;
	else if (action.startsWith("40") && action.length === 5) rPercent = parseFloat(action.substring(2)) / 100;
	if (rPercent === 0) throw new Error("raise percent shouldn't be 0");
	return rPercent;
}
